import { GetServerSidePropsContext } from "next";
import Layout from "components/Layout";
import SchoolBoxLanding from "components/SchoolBox/SchoolBoxLanding";
import { getClassroom, getSchoolByAffiliateId } from "lib/api/affiliates";
import { isAPIError } from "lib/api/base";
import { Affiliate } from "components/SchoolBox/schoolBoxTypes";
import { getSubscriptionPlans } from "lib/api/checkout";

type SchoolboxServerSideProps = ServerSideProps<typeof getServerSideProps>;

/**
 * Renders school affiliation page component.
 */
const SchoolBoxPage = (props: SchoolboxServerSideProps) => {
  return (
    <Layout pageTitle="School Box" noContainer>
      <SchoolBoxLanding {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const extAffiliateCode = ctx.query.extAffiliateCode as string;
  if (!extAffiliateCode) {
    const plansRes = await getSubscriptionPlans(ctx);

    return {
      props: {
        affiliate: null,
        plans: isAPIError(plansRes) ? [] : plansRes,
      },
    };
  }

  const [classroomRes, plansRes, schoolRes] = await Promise.all([
    getClassroom(extAffiliateCode),
    getSubscriptionPlans(ctx),
    getSchoolByAffiliateId({ affiliateId: extAffiliateCode }),
  ]);

  const school = isAPIError(schoolRes) ? null : schoolRes;

  const classroom =
    isAPIError(classroomRes) || !classroomRes?.classroom ? null : classroomRes;

  const affiliate: Affiliate | null = school || classroom;

  return { props: { affiliate, plans: isAPIError(plansRes) ? [] : plansRes } };
}

export default SchoolBoxPage;
